export const DATABASE_SEARCH_EVENTS = {
  FILTERS: 'Database Search - Filters',
  SAVED: 'Database Search - Saved',
  CLEAR_ALL: 'Database Search - Clear All Filters',

  ACCOUNTS: {
    BASE: 'DB - Accounts',
    TABS: {
      TOTAL: 'Database Search - Contacts Total',
      NET_NEW: 'Database Search - Contacts Net New',
      MOVED_TO_TAL: 'Database Search - Contacts Moved to TAL',
    },
    EDIT_VIEW: 'Database Search - Accounts Edit View',
    MOVE_TO_TARGET: 'Database Search - Accounts Move to Target Profile',
    SAVE_TO_TAL: 'DB  - Accounts - Qualify',
    SAVE_TO_TAL_CANCEL: 'DB  - Accounts - Qualify - Cancel',
    SAVE_TO_TAL_CONFIRM: 'DB  - Accounts - Qualify',
    SAVE_TO_TAL_SKIP_CONTACTS: 'DB  - Accounts - Qualify - Skip & Qualify',
    CLEAR_FILTER: 'Database Search - Accounts Clear Filter',
    CLEAR_SELECTION: 'Database Search - Accounts Clear Selection',
    CLEAR_INDIVIDUAL_FILTER: 'Database Search - Accounts Clear Individual Filter',

    ALL_CONTACT_FILTERS: 'Database Search - Accounts - All Contact Filters',
    SELECT_OPTIONS: 'Database Search - Accounts - Select Options',
    EXCLUDES_FILTER: 'Database Search - Accounts - Excludes Filter',
    SAVE_SEARCH: 'Database Search - Accounts - Save Search',

    LISTING_FILTERED: {
      FILTERS: 'Database Search - Accounts listing filters',
      SAVED: 'Database Search - Accounts listing saved',
      EXPAND: 'Database Search - Accounts listing filter expand',
      COLLAPSE: 'Database Search - Accounts listing filter collapse',
      CLEAR: 'Database Search - Accounts listing filter clear',
      CLEAR_ALL: 'Database Search - Accounts listing filter clear all',
      SELECTED_FILTERS: 'Database Search - Accounts listing filter selected',
      SAVE_SEARCH: 'Database Search - Accounts listing filter save search',
    },

    LATEST_SAVED_SEARCHES: 'Database Search - Accounts 3 Latest Saved Searches',
    RECENT_SEARCHES: 'Database Search - Accounts 3 Recent Searches',

    ACCOUNT_DETAILS: {
      SIDE_DRAWER_CLICK: 'DB  - Accounts - Side Drawer Click',
      SIDE_DRAWER_DOMAIN_CLICK: 'DB  - Accounts - Side Drawer - Domain',
      SIDE_DRAWER_LINKEDIN_CLICK: 'DB  - Accounts - Side Drawer - LinkedIn',
      AD_ADD_TO_LIST: 'DB  - Accounts - Side Drawer - Add to List',
      AD_SAVE_TO_LIST: 'DB  - Accounts - Side Drawer - Add to List - Save',
      AD_QUALIFY: 'DB  - Accounts - Side Drawer - Qualify',
      AD_SKIP_AND_QUALIFY: 'DB  - Accounts - Side Drawer - Qualify - Skip & Qualify',
      AD_QUALIFY_AND_PROCEED: 'DB  - Accounts - Side Drawer - Qualify - Proceed',
      AD_QUALIFY_CANCEL: 'DB  - Accounts - Side Drawer - Qualify - Cancel',
      AD_SEE_MORE_DESC: 'DB  - Accounts - Side Drawer - See More Description',
      AD_SEE_MORE_COMPANY_KEYS: 'DB  - Accounts - Side Drawer - See More Company Keywords',
      AD_SEE_MORE_JOB_OPENINGS: 'DB  - Accounts - Side Drawer - See More Job Openings',
    },
  },
  CONTACTS: {
    BASE: 'Database Search - Contacts',
    SEARCH_CONTACT: 'Database Search - Contacts Search Contact',
    TABS: {
      TOTAL: 'DB - Contacts Total',
      NET_NEW: 'DB - Contacts Net New',
      MOVED_TO_TAL: 'DB - Contacts Moved to TAL',
    },
    EDIT_VIEW: 'Database Search - Contacts Edit View',
    ADD_TO_LIST: 'DB - Save Contacts to List',
    ADD_TO_LIST_CONFIRM: 'DB - Save Contacts to List Confirm',
    ADD_TO_LIST_CANCEL: 'DB - Save Contacts to List Cancel',
    MOVE_TO_TARGET: 'Database Search - Contacts Move to Target',
    SAVE_TO_TAL: 'DB  - Contacts - Qualify',
    SAVE_TO_TAL_CANCEL: 'DB  - Contacts - Qualify - Cancel',
    SAVE_TO_TAL_CONFIRM: 'DB  - Contacts - Qualify',
    CLEAR_FILTER: 'Database Search - Contacts Clear Filter',

    ACTIONS: {
      ADD_TO_LIST: 'Database Search - Contacts actions Add to List',
      MOVE_TO_TARGET: 'Database Search - Contacts actions Move to Target',
    },
    SAVE_SEARCH: 'Database Search - Contacts Save Search',
    CLEAR_SELECTION: 'Database Search - Contacts Clear Selection',
    CLEAR_INDIVIDUAL_FILTER: 'Database Search - Contact Clear Individual Filter',

    ALL_CONTACT_FILTERS: 'Contacts - All Contact Filters',
    EXCLUDES_FILTER: 'Contacts - Excludes Filter',

    LISTING_FILTERED: {
      FILTERS: 'Database Search - Contacts listing filters',
      SAVED: 'Database Search - Contacts listing saved',
      EXPAND: 'Database Search - Contacts listing filter expand',
      COLLAPSE: 'Database Search - Contacts listing filter collapse',
      CLEAR: 'Database Search - Contacts listing filter clear',
      CLEAR_ALL: 'Database Search - Contacts listing filter clear all',
      SELECTED_FILTERS: 'Database Search - Contacts listing filter selected',
      SAVE_SEARCH: 'Database Search - Contacts listing filter save search',
    },

    LATEST_SAVED_SEARCHES: 'Database Search - Contacts - 3 Latest Saved Searches',
    RECENT_SEARCHES: 'Database Search - Contacts 3 Recent Searches',

    CREDITS_USAGE: 'Database Search - Contacts Credits Usage: Contact Customer Success',
    DETAILS_SIDEBAR: {
      CONTACT_NAME_TABLE_ACTION: 'DB  - Contacts - Side Drawer Click',
      CONTACT_SIDEBAR_LINKEDIN_ACTION: 'DB  - Contacts - Side Drawer - LinkedIn',
      CONTACT_SIDEBAR_COMPANY_NAME_ACTION: 'DB  - Contacts - Side Drawer - Company Info Drawer',
      CONTACT_SIDEBAR_ADD_TO_LIST_ACTION: 'DB  - Contacts - Side Drawer - Add to List',
      CONTACT_SIDEBAR_ADD_TO_LIST_SAVE_ACTION: 'DB  - Contacts - Side Drawer - Add to List - Save',
      CONTACT_SIDEBAR_QUALIFY_ACTION: 'DB  - Contacts - Side Drawer - Qualify',
      CONTACT_SIDEBAR_QUALIFY_YES_ACTION: 'DB  - Contacts - Side Drawer - Qualify - Proceed',
      CONTACT_SIDEBAR_OVERVIEW_ACTION: 'DB  - Contacts - Side Drawer - See More Description',
      CONTACT_SIDEBAR_VIEW_ALL_EMPLOYEES_ACTION:
        'DB  - Contacts - Side Drawer - See More Employee History',
      CONTACT_SIDEBAR_VIEW_ALL_EDUCATION_ACTION:
        'DB  - Contacts - Side Drawer - See More Education',
      CONTACT_SIDEBAR_ACCOUNT_DOMAIN_ACTION:
        'DB  - Contacts - Side Drawer - Account Overview - Domain',
      CONTACT_SIDEBAR_ACCOUNT_LINKEDIN_ACTION:
        'DB  - Contacts - Side Drawer - Account Overview - LinkedIn URL',
      CONTACT_SIDEBAR_REVEAL_CONTACT_INFO_ACTION: 'DB  - Contacts - Side Drawer - Enrich',
    },
  },
};
